import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { MODAL_TYPE_SEARCH_TAG_FILTER } from '../../../../actions/ModalActions';
import { searchParamSet } from '../../../../actions/SearchSolutionActions';
import { propArrayShape, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import Modal from '../../../Ui/Modal';
import TagFilterModalContent from './TagFilterModalContent';
const TagFilterModal = (props) => {
    const { params, setParam, solutionTag, solutionTagClass } = props;
    return (_jsx(Modal, Object.assign({ hideRemove: true, modalType: MODAL_TYPE_SEARCH_TAG_FILTER }, { children: _jsx(TagFilterModalContent, { params: params, setParam: setParam, solutionTag: solutionTag, solutionTagClass: solutionTagClass }) })));
};
TagFilterModal.propTypes = {
    params: propShape().isRequired,
    setParam: propFunc().isRequired,
    solutionTag: propArrayShape().isRequired,
    solutionTagClass: propArrayShape().isRequired,
};
const mapStateToProps = ({ category, searchSolution }) => ({
    params: searchSolution.params || {},
    solutionTag: category.solutionTag || [],
    solutionTagClass: category.solutionTagClass || [],
});
const mapDispatchToProps = (dispatch) => ({
    setParam: (payload) => {
        if (Object.keys(payload)) {
            dispatch(searchParamSet(payload));
        }
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(TagFilterModal);
